import React, { ReactElement } from 'react'
import Divider from '../Divider'
import CrazyOverview from './CrazyOverview'

const CrazyPanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <CrazyOverview />
        </div>
    )
}

export default CrazyPanel
